import { Modal, Button, Divider } from 'antd';
import React, { useState, useEffect } from 'react';
import TextInfo from '../../../../components/common/TextInfo/TextInfo';
import Select from "react-select";

export default function ModalVoucherSetting({ visible, onClose, selected, setDataVoucher, dataVoucher, onSubmit, errors }) {
    const [detail, setDetail] = useState()
    const [selectedPeriod, setSelectedPeriod] = useState()

    useEffect(() => {
        if (!selected) return
        setDetail(selected.detail)
        setDataVoucher((prev) => ({
            ...prev,
            gadaiId: selected?.id,
        }))
        if (selected.paymentType === 'installment') {
            if (!selected.installmentId) {
                setSelectedPeriod(selected?.installments[0] || [])
            } else {
                selected?.installments.map(item => {
                    if (selected.installmentId === item.value.id) setSelectedPeriod(item)
                })
            }
            setDataVoucher((prev) => ({
                ...prev,
                installmentId: selected?.installments[0]?.value.id
            }))
        }
        console.log('selected', selected)
    }, [selected]);

    const handleSelect = (e) => {
        setSelectedPeriod(e)
        setDetail(e.value)
        setDataVoucher((prev) => ({
            ...prev,
            installmentId: e.value.id
        }))
    }

    const handleInputName = (e) => {
        setDataVoucher((prev) => ({
            ...prev,
            name: e.target.value
        }))
    }

    const handleInputAmount = (e) => {
        setDataVoucher((prev) => ({
            ...prev,
            amount: e.value
        }))
    }
    return (
        <Modal
            centered
            title="Atur Voucher"
            className="modal-form"
            visible={visible}
            onCancel={onClose}
            width={500}
            footer={[
                <Button
                    onClick={onClose}
                    style={{
                        border: "0.75px solid #DCDCDC",
                        borderRadius: 6,
                        width: 120,
                        height: 36,
                        color: "#000",
                        background: "#FFFFFF",
                    }}
                >
                    Sebelumnya
                </Button>,
                <Button
                    onClick={onSubmit}
                    style={{
                        border: "0.75px solid #DCDCDC",
                        borderRadius: 6,
                        width: 120,
                        height: 36,
                        color: "#fff",
                        background: "#2C465C",
                    }}
                >
                    Simpan
                </Button>
            ]}
        >

            <div>
                <div className="detail-header my-2">
                    <TextInfo
                        title="No. SBG"
                        value={selected.sbg}
                    />
                </div>
                <div className="detail-header my-2">
                    <TextInfo
                        title="Nama Nasabah"
                        value={selected.customerName}
                    />
                </div>
                <Divider dashed className="detail-divider" />

                {
                    selected.paymentType === 'installment' &&
                    <div className="detail-header my-4 align-items-center">
                        <div className="modal-title">Pilih Periode Cicilan</div>
                        <Select
                            value={selectedPeriod}
                            onChange={handleSelect}
                            isMulti={false}
                            options={selected.installments}
                            className="basic-multi-select"
                            styles={{
                                control: (styles) => ({
                                    ...styles,
                                    width: "100%",
                                }),
                                multiValue: (styles) => {
                                    return {
                                        ...styles,
                                        backgroundColor: "#F6F6F6",
                                    };
                                },
                            }}
                        />
                    </div>
                }
                <div className="detail-header my-2">
                    <TextInfo
                        title="Tagihan Pokok"
                        value={detail?.billAmount}
                    />
                </div>
                <div className="detail-header my-2">
                    <TextInfo
                        title="Sewa Modal"
                        value={detail?.capitalLoan}
                    />
                </div>
                {
                    selected.paymentType === 'installment' && selected.interestExpense.includes('behind') &&
                    <div className="detail-header my-2">
                        <TextInfo
                            title="Simpan & Asuransi"
                            value={detail?.savingInsurance}
                        />
                    </div>
                }
                {
                    selected.paymentType === 'installment' ?
                        <>
                            <div className="detail-header my-2">
                                <TextInfo
                                    title="Denda Keterlambatan"
                                    value={detail?.feeLatePeriod}
                                />
                            </div>
                            <div className="detail-header my-2">
                                <TextInfo
                                    title="Denda Harian"
                                    value={detail?.feeLateDays}
                                />
                            </div>
                        </>
                        :
                        <>
                            <div className="detail-header my-2">
                                <TextInfo
                                    title="Simpan Keterlambatan"
                                    value={detail?.feeSaving}
                                />
                            </div>
                            <div className="detail-header my-2">
                                <TextInfo
                                    title="Denda Keterlambatan"
                                    value={detail?.feeLate}
                                />
                            </div>
                        </>
                }
                <Divider dashed className="detail-divider" />
                <div className="detail-header my-2">
                    <TextInfo
                        title="Nama Voucher"
                        value={dataVoucher.name}
                        type={"input"}
                        id={"name"}
                        handleChange={handleInputName}
                        error={errors?.name}
                        isForm
                        isTextArea
                    />
                </div>
                <div className="detail-header my-2">
                    <TextInfo
                        title="Jumlah Potongan"
                        value={dataVoucher.amount}
                        type={"input"}
                        id={"amount"}
                        handleChange={handleInputAmount}
                        error={errors?.amount}
                        isForm
                        isInputNumber
                    />
                </div>
            </div>

        </Modal>
    )
}
